import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter } from 'react-router-dom'
import Navbar from './components/navbar/navbar.jsx'
import Footer from './components/footer/footer.jsx'
import Routes from './routes.jsx'

const queryClient = new QueryClient({})

const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
    <>
      <Navbar />
      <div className="body">
        <Routes />
      </div>
      <Footer />
    </>
    </BrowserRouter>
  </QueryClientProvider>
)

export default App